import { z } from 'zod';
import type { AISchemaField, UISchemaField } from '../types/index';

export const faqAISchema: AISchemaField[] = [
  { name: 'eyebrow', type: 'string', required: false, max: 30 },
  { name: 'headline', type: 'string', required: true, max: 80 },
  { name: 'subheadline', type: 'string', required: false, max: 200 },
  {
    name: 'items',
    type: 'array<object>',
    required: true,
    fields: [
      { name: 'question', type: 'string', required: true, max: 120 },
      { name: 'answer', type: 'string', required: true, max: 400 },
      { name: 'category', type: 'string', required: false, max: 30 },
    ],
  },
];

export const faqUISchema: UISchemaField[] = [
  { name: 'eyebrow', type: 'text', label: 'Eyebrow', max: 30 },
  { name: 'headline', type: 'text', label: 'Headline', required: true, max: 80 },
  { name: 'subheadline', type: 'textarea', label: 'Subheadline', max: 200 },
  { name: 'items', type: 'qa_list', label: 'FAQ items', required: true },
];

export const faqZodSchema = z.object({
  eyebrow: z.string().max(30).optional().nullable(),
  headline: z.string().min(1).max(80),
  subheadline: z.string().max(200).optional().nullable(),
  items: z
    .array(
      z.object({
        question: z.string().max(120),
        answer: z.string().max(400),
        category: z.string().max(30).optional().nullable(),
      }),
    )
    .min(1),
});

export type FaqContent = z.infer<typeof faqZodSchema>;

export const faqSample: FaqContent = {
  eyebrow: 'FAQ',
  headline: 'Everything you might ask.',
  subheadline: 'If your question is not here, our team replies in under 4 hours.',
  items: [
    {
      question: 'Is there a free trial?',
      answer: 'Yes — 14 days, full features, no credit card.',
      category: 'Pricing',
    },
    {
      question: 'Can I cancel anytime?',
      answer: 'Of course. Cancel from the billing page in two clicks.',
      category: 'Pricing',
    },
    {
      question: 'Do you offer SSO?',
      answer: 'On the Pro and Studio plans. Reach out and we’ll set it up.',
      category: 'Security',
    },
    {
      question: 'Where is my data stored?',
      answer: 'In the region you choose at signup. Currently US, EU, and Tokyo.',
      category: 'Security',
    },
  ],
};
